/*
  © 2026 Finale Media
  Gift Card Recipient Form — collection-based multi-product selection
*/

class GiftCardForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    this.priceSelect = this.querySelector('#gift-card-price')
    this.variantWrapper = this.querySelector('#gift-card-variant-wrapper')
    this.variantSelect = this.querySelector('#gift-card-theme')
    this.priceDisplay = this.querySelector('#gift-card-price-display')
    this.priceDisplaySpan = this.querySelector('#gift-card-price-display span')
    this.messageTextarea = this.querySelector('#recipient-message')
    this.charCount = this.querySelector('#message-char-count')
    this.submitBtn = this.querySelector('#gift-card-submit')

    const dataEl = document.getElementById('gift-card-products-data')
    this.products = dataEl ? JSON.parse(dataEl.textContent) : []

    this.init()
  }

  init () {
    if (this.messageTextarea && this.charCount) {
      this.messageTextarea.addEventListener('input', () => this.updateCharCount())
      this.updateCharCount()
    }

    if (this.priceSelect) {
      this.priceSelect.addEventListener('change', () => this.onPriceChange())
    }

    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', () => this.onVariantChange())
    }

    this.form.addEventListener('submit', (e) => this.onSubmit(e))
  }

  onPriceChange () {
    const productId = parseInt(this.priceSelect.value, 10)
    const product = this.products.find(p => p.id === productId)
    if (!product) return

    // Clear and repopulate variant select using safe DOM methods
    while (this.variantSelect.firstChild) {
      this.variantSelect.removeChild(this.variantSelect.firstChild)
    }

    const placeholder = document.createElement('option')
    placeholder.value = ''
    placeholder.disabled = true
    placeholder.selected = true
    placeholder.textContent = 'Select Theme'
    this.variantSelect.appendChild(placeholder)

    product.variants.forEach(variant => {
      const opt = document.createElement('option')
      opt.value = variant.id
      opt.dataset.price = variant.price_formatted
      opt.disabled = !variant.available
      opt.textContent = variant.title + (variant.available ? '' : ' — Sold Out')
      this.variantSelect.appendChild(opt)
    })

    this.variantWrapper.style.display = ''
    this.priceDisplay.style.display = 'none'
    this.submitBtn.disabled = true

    // Auto-select first available variant
    const firstAvailable = product.variants.find(v => v.available)
    if (firstAvailable) {
      this.variantSelect.value = firstAvailable.id
      this.onVariantChange()
    }
  }

  onVariantChange () {
    const selectedOpt = this.variantSelect.options[this.variantSelect.selectedIndex]
    if (!selectedOpt || !selectedOpt.value) return

    this.priceDisplaySpan.textContent = selectedOpt.dataset.price
    this.priceDisplay.style.display = ''
    this.submitBtn.disabled = false
  }

  updateCharCount () {
    const len = this.messageTextarea.value.length
    this.charCount.textContent = len
    this.charCount.classList.toggle('text-danger', len >= 200)
  }

  onSubmit (event) {
    const emailInput = this.querySelector('#recipient-email')
    const email = emailInput.value.trim()

    if (!email || !this.isValidEmail(email)) {
      event.preventDefault()
      emailInput.classList.add('is-invalid')
      emailInput.setAttribute('aria-invalid', 'true')

      let errorDiv = emailInput.parentElement.querySelector('.invalid-feedback')
      if (!errorDiv) {
        errorDiv = document.createElement('div')
        errorDiv.className = 'invalid-feedback d-block'
        emailInput.parentElement.appendChild(errorDiv)
      }
      errorDiv.textContent = 'Please enter a valid email address'
      emailInput.focus()
      return
    }

    if (!this.variantSelect.value) {
      event.preventDefault()
      this.variantSelect.classList.add('is-invalid')
      return
    }

    emailInput.classList.remove('is-invalid')
    emailInput.removeAttribute('aria-invalid')
    this.variantSelect.classList.remove('is-invalid')
  }

  isValidEmail (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }
}

customElements.define('gift-card-form', GiftCardForm)
